module.exports = __webpack_public_path__ + "static/media/sf-test-2.d057e7e7.mp3";